import { render, staticRenderFns } from "./notice-modal2.vue?vue&type=template&id=d5a8cc02&scoped=true"
import script from "./notice-modal2.vue?vue&type=script&lang=js"
export * from "./notice-modal2.vue?vue&type=script&lang=js"
import style0 from "./notice-modal2.vue?vue&type=style&index=0&id=d5a8cc02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a8cc02",
  null
  
)

export default component.exports